import { render } from "./SelectIdCard.vue?vue&type=template&id=9b9a8c9e&scoped=true&ts=true"
import script from "./SelectIdCard.vue?vue&type=script&lang=ts"
export * from "./SelectIdCard.vue?vue&type=script&lang=ts"

import "./SelectIdCard.vue?vue&type=style&index=0&id=9b9a8c9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b9a8c9e"],['__file',"src/components/kyc/SelectIdCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9b9a8c9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9b9a8c9e', __exports__)) {
    api.reload('9b9a8c9e', __exports__)
  }
  
  module.hot.accept("./SelectIdCard.vue?vue&type=template&id=9b9a8c9e&scoped=true&ts=true", () => {
    api.rerender('9b9a8c9e', render)
  })

}


export default __exports__